<template>
<div class="welcome" style="position: relative; bottom: 0%;">
    <form v-on:submit.prevent="register()">
          <h1 class="reg-title">{{ $t('registration.title') }}</h1>
                <section>
                      <p class="field">
                            <label for="firstname">
                                    <span>{{ $t('registration.first_name_label') }} </span>
                                    <strong><abbr class="required" title="required">*</abbr></strong>
                                  </label>
                              <input type="text" id="first_name" v-model="first_name" autocomple="off">
                <div v-if="this.response && !loading">
                    <p class="validation animated shake" v-bind:key="error" v-for="error in this.response.errors.first_name">{{ error }}</p>
                </div>
            </p>
                        <p class="field">
                              <label for="lastname">
                                    <span>{{ $t('registration.last_name_label') }} </span>
                                    <strong><abbr class="required" title="required">*</abbr></strong>
                                  </label>
                              <input type="text" id="last_name" v-model="last_name" autocomple="off">
                <div v-if="this.response && !loading">
                    <p class="validation animated shake" v-bind:key="error" v-for="error in this.response.errors.last_name">{{ error }}</p>
                </div>
            </p>
                        <p class="field">
                              <label for="email">
                                    <span>{{ $t('registration.email_label') }} </span>
                                    <strong><abbr class="required" title="required">*</abbr></strong>
                                  </label>
                              <input type="email" id="email" v-model="email">
                <div v-if="this.response && !loading">
                    <p class="validation animated shake" v-bind:key="error" v-for="error in this.response.errors.email">{{ error }}</p>
                </div>
            </p>
            <label class="chekbox_field">
                <p v-html="$t('registration.i_agree')"></p>
                <input type="checkbox" v-model="terms" v-on:change="!showTermsError">
                <span class="checkmark" style="left: calc(6% - 20px);"></span>
            </label>
            <div v-if="this.response && !loading">
                <p class="validation animated shake" v-bind:key="error" v-for="error in this.response.errors.terms">{{ error }}</p>
            </div>
            <label class="chekbox_field">
                <p v-html="$t('registration.i_accept')"></p>
                <input type="checkbox" v-model="terms_two">
                <span class="checkmark" style="left: calc(6% - 20px);"></span>
            </label>
            <p v-html="$t('registration.pp_data')"></p>
        </section>
        <button class="primary_btn" v-bind:class="{'disabled': !first_name || !last_name || !email}" :disabled="!first_name || !last_name || !email" v-if="!loading" v-on:click="register()">{{ $t('registration.button')}}</button>
        <center>
            <spring-spinner :animation-duration="3000" :size="60" color="#ef0000" v-if="loading" />
        </center>
    </form>
</div>
</template>

<script>
import axios from 'axios';
import appStyles from '@/styles/appStyles.scss'
import {
    SpringSpinner
} from 'epic-spinners'

export default {
    name: 'register',
    components: {
        appStyles,
        SpringSpinner,
    },
    data() {
        return {
            date: '',
            home: '',
            data: '',
            email: '',
            terms: '',
            terms_two: '',
            response: '',
            first_name: '',
            last_name: '',
            auth: false,
            loading: false,
            showTermsError: true
        }
    },
    methods: {
        register: function () {

            this.loading = true;
            this.response = null;

            var data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                terms: this.terms ? this.terms : '',
                terms_two: this.terms_two ? this.terms_two : ''
            };

            // console.log(data);
            setTimeout(() => {
                axios({
                    method: 'POST',
                    url: this.$t('API_BASE_URL') + '/api/v1/create-user',
                    data: data,
                    headers: {
                        "content-type": "application/x-www-form-urlencoded"
                    }
                }).then(response => {
                    // RS API responded, loading complete
                    this.loading = false;
                    this.date = new Date();
                    this.data = response.data;
                    // Get and set validation error messages
                    this.response = response.status === 201 ? null : response.data;
                    // Redirect successful registration
                    (response.status === 201) ? (this.$router.push({
                        path: `/instructions`
                    })) : null;
                    // Set session key-values
                    (response.status === 201) ? (this.$session.set('logged_in', true)) : null;
                    this.$session.get('logged_in') ? (this.$session.set('timeout', this.date.getTime() / 1000)) : null;

                    this.$session.set('session_play', this.data.id);
                    // console.log(response.data);
                    // console.log(response.status);
                    // console.log(response.data.errors);
                    // console.log(response.data.message);
                }).catch((error) => {
                    this.loading = false;
                    // Error 😨
                    if (error.response) {
                        /*
                         * Request was made and the server responded with a
                         * status code that falls out of the range of 2xx
                         */
                        var get_error = error.response.data.error.message;
                        if (get_error === 'User Already Exists' && error.response.status === 400) {
                            this.date = new Date();
                            this.$session.set('logged_in', true);
                            this.$session.set('timeout', this.date.getTime() / 1000);
                            this.$session.set('user', {
                                id: this.data.id,
                                first_name: this.data.first_name,
                                last_name: this.data.last_name,
                                email: this.data.email
                            });
                            this.$router.push({
                                path: `/instructions`
                            });
                        }
                        // console.log(error.response.data.error.message);
                        // console.log(error.response.status);

                    } else if (error.request) {
                        // The request was made but no response was received
                        // console.log(error.request);
                    } else {
                        // Something happened in setting up the request and triggered an Error
                        // console.log('Error', error.message);
                    }
                    // console.log(error.config);
                });
            }, 600);

        }
    },
    mounted() {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.tc_link {
    color: #5f259f;
    text-decoration: none;
}
@media (max-height: 700px) {
    .background {
        min-height: calc(100% + 250px) !important;
    }
}
/* @media (min-height : 736px) and (max-height : 812px) {
    .reg-title {
        margin-top: 250px !important;
    }
}    */

/*.background {
            min-height: calc(100% + 50px);
        }*/
</style>
